export default "__VITE_ASSET__BrvDWJd6__"